import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { useEntityRepository } from '../../../hooks/entity/useEntityRepository';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';

export function useConfigureTimeTrackingActivityAdminPageBreadcrumbs(
  compilation: TimeTrackingActivityCompilation,
  parentActivityId: string | null | undefined
): void {
  const repository = useEntityRepository(EntityName.TimeTrackingActivity);

  useConfigureBreadcrumbsWithBuilder((builder) => {
    builder
      .addHomePage()
      .addTimeTrackingActivityCompilationAdminPage(compilation.ownerUserGroupId)
      .addTimeTrackingActivityAdminPage(compilation.id, null);

    const path = parentActivityId ? repository.getPath(parentActivityId) : [];
    for (const activity of path) {
      if (activity) {
        builder.addTimeTrackingActivityAdminPage(compilation.id, activity.id);
      }
    }
  });
}
